import {OrangeOptechDemo} from './components/OrangeOptechDemo/OrangeOptechDemo';
import { useViewportSize } from './hooks/useViewportSize';

function App({
  hubspotPortalId,
  hubspotFormId
}) {
  useViewportSize();
  return (
    <OrangeOptechDemo
      hubspotPortalId={hubspotPortalId}
      hubspotFormId={hubspotFormId}
    />
  );
}

export default App;
